<template>
	<router-link :to="{ name: 'view-user', params: { user_id: rowData.id } }" class="user">
		<img v-if="rowData.avatar" :src="`/images/avatar/${rowData.id}`"
		     class="avatar avatar--small"
		     :title="rowData.name" :alt="`${rowData.name}'s avatar`"
		     :key="rowData.id"
			 width="32" height="32" />
		<img v-else src="//placehold.it/32x32" class="avatar avatar--small" width="32" height="32" />
		<span>{{ rowData.name }}</span>
	</router-link>
</template>

<script>
	export default {
		name: 'ColumnUser',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
		//Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>

<style lang="scss">
	@import "~reflex-grid/scss/includes/variables";
	@import "~reflex-grid/scss/includes/mixins";

	.user {
		@include display-flex;
		@include align-items(center);
	}

	.avatar {
		margin-right: 1rem;
	}
</style>
